import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import ShippingSettingsComponent from './shipping-settings.component';
import ShippingTypeSettingsComponent from './shippingType-settings.component';
import ShippingOptionSettingsComponent from './shipping-option-settings.component';
import DeliveryHubSettingsComponent from './delivery-hub-setting.component';
import ServiceabilitySettingsComponent from './serviceability-setting.component';
import TripManagementComponent from './trip-management.component';

export const LogisticsSettingsComponent = ({ handleInnerFormChange, selectLogisticsSettings, handleFormSubmit }: any) => {

    const tabItems = [
        {
            id: 1,
            title: 'Shipping Settings',
            component: <ShippingSettingsComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'ShippingType Settings',
            component: <ShippingTypeSettingsComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'ShippingOption Settings',
            component: <ShippingOptionSettingsComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        },
        {
            id: 4,
            title: 'DeliveryHub Settings',
            component: <DeliveryHubSettingsComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        },
        {
            id: 5,
            title: 'Serviceability Settings',
            component: <ServiceabilitySettingsComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        },
         {
            id: 6,
            title: 'Trip management',
            component: <TripManagementComponent
                selectLogisticsSettings={selectLogisticsSettings}
                handleInnerFormChange={handleInnerFormChange}

            />,
            isVisible: true,
        }
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default LogisticsSettingsComponent;
